export default __webpack_public_path__ + "static/media/highlight.bcfd5ac2.png";